<template>
  <el-dialog
    title="更新资源类型"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-escape="false"
    width="500px"
    @closed="handleClose"
  >
    <el-form
      ref="editForm"
      :model="formData"
      :rules="formRules"
      label-width="120px"
      size="small"
    >
      <el-form-item label="资源类型名称：" prop="name">
        <el-input v-model="formData.name" placeholder="请输入资源类型名称" />
      </el-form-item>
      <el-form-item label="状态：" prop="status">
        <el-select v-model="formData.status" placeholder="请选择状态" style="width: 100%;">
          <el-option label="有效" :value="0"></el-option>
          <el-option label="无效" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="父ID：" prop="p_id" style="display: none;">
        <el-input type="number" v-model="formData.p_id" placeholder="请输入父ID（可选）"></el-input>
      </el-form-item>
      <el-form-item label="备注：" prop="remark">
        <el-input type="textarea" :rows="3" v-model="formData.remark" placeholder="请输入备注（可选）"></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit" :loading="submitLoading">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditComputeType',

  data() {
    return {
      dialogVisible: false,
      computeTypeId: '',
      submitLoading: false,
      formData: {
        name: '',
        status: 0,
        p_id: '',
        remark: ''
      },
      formRules: {
        name: [
          { required: true, message: '请输入资源类型名称', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      }
    };
  },

  methods: {
    /**
     * 打开编辑弹窗
     */
    openDialog(row) {
      if (!row || !row.id) {
        this.$message.error('无效数据');
        return;
      }

      this.computeTypeId = row.id;
      this.resetForm();

      // 填充数据
      Object.assign(this.formData, {
        name: row.name == null ? '' : row.name,
        status: row.status == null ? 0 : row.status,
        p_id: row.p_id == null ? '' : row.p_id,
        remark: row.remark == null ? '' : row.remark
      });

      this.dialogVisible = true;

      this.$nextTick(() => {
        if (this.$refs.editForm) {
          this.$refs.editForm.clearValidate();
        }
      });
    },

    handleClose() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.computeTypeId = '';
    },

    resetForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
    },

    /**
     * 提交表单（PUT 请求）
     */
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return;

        const payload = { ...this.formData };
        this.submitLoading = true;

        this.$axios.put(`/api-30216/api/compute-types/${this.computeTypeId}`, payload, {
          headers: { 'Content-Type': 'application/json' },
          transformRequest: [payload => JSON.stringify(payload)]
        })
          .then(res => {
            const data = res.data || res;
            if (data.code === 200) {
              this.$message.success(data.message || '更新成功');
              this.dialogVisible = false;
              this.$emit('success'); // 通知父组件刷新
            } else {
              this.$message.error(data.message || '更新失败');
            }
          })
          .catch(err => {
            const msg = err.response && err.response.data && err.response.data.message || err.message || '请求失败';
            this.$message.error(msg);
            console.error('提交错误:', err);
          })
          .finally(() => {
            this.submitLoading = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>